<template>
  <div class="button-container">
    <a
      ref="button"
      :style="{ width: width, height: height }"
      @mouseenter="mouseenter"
      @mousemove="mousemove"
      @mouseleave="mouseleave"
      @click="goto(href)"
      >{{ text }}</a
    >
    <div ref="diffusedBlock" class="diffused-block"></div>
  </div>
</template>

<script>
export default {
  props: {
    href: String,
    text: String,
    width: {
      type: String,
      default: "288px",
    },
    height: {
      type: String,
      default: "48px",
    },
  },
  methods: {
    mouseenter() {
      this.$refs.diffusedBlock.style.opacity = 1;
    },
    mousemove(e) {
      const button = this.$refs.button;
      const diffusedBlock = this.$refs.diffusedBlock;
      const rect = button.getBoundingClientRect();
      const x = e.clientX - rect.left - diffusedBlock.offsetWidth / 2;

      // 确保色块在按钮内
      const minX = 0;
      const maxX = rect.width - diffusedBlock.offsetWidth;

      const clampedX = Math.max(minX, Math.min(x, maxX));

      diffusedBlock.style.transform = `translate(${clampedX}px, ${10}px)`;
    },
    mouseleave() {
      this.$refs.diffusedBlock.style.opacity = 0;
    },
    goto(href) {
      this.$router.push(href);
    },
  },
};
</script>

<style scoped>
.button-container {
  position: relative;
  display: inline-block;
  overflow: hidden;
  border-radius: 8px;
}

a {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  border-radius: 8px;
  background: #1cb3b8;
  text-align: left;
  padding: 0 24px;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  position: relative;
  text-decoration: none;
  overflow: hidden;
  box-sizing: border-box;
  cursor: pointer;
}

a::after {
  content: "→";
  position: absolute;
  right: 24px;
  top: 50%;
  color: #fff;
  transform: translateY(-50%);
  font-size: 20px;
}

a:hover {
  transform: scale(1.01);
}

.diffused-block {
  position: absolute;
  width: 80px;
  height: 80px;
  background: radial-gradient(
    circle,
    rgba(18, 96, 219, 1) 0%,
    rgba(18, 96, 219, 1) 50%
  );
  border-radius: 50%;
  filter: blur(20px);
  pointer-events: none;
  transition: opacity 0.3s ease;
  top: -24px;
  left: 0;
  opacity: 0;
}
</style>
